import React, { useEffect, useState } from "react";
import goToScreen from "../lib/goToScreen";
import ConfirmDetails from "../Components/ConfirmDetails";
import addIntercom from "../lib/addIntercom";
import Loader from "../Components/Loader";
import BackgroundPhoto from "../Components/BackgroundPhoto";
import { Button } from "react-bootstrap";
import isSiteBuilder from "../lib/isSiteBuilder";

export default function Confirm({ history }) {
  document.title = "Onboarding";

  const [loading, setLoading] = useState(true);
  const [repeatYoti, setRepeatYoti] = useState(false);
  const [details, setDetails] = useState({});

  useEffect(() => {
    function handleChange(response) {
      addIntercom(
        response.Intercom,
        response.kycData ? response.kycData.full_name : null,
        response.person_details.current_email,
        response.person_details.current_AccountId,
        response.account_details.account_type,
        false
      );

      const country_code_iso2 = response.account_details.country_code || "GB";
      const account_country_code =
        response.account_details.country_code_iso3 || "GBR";

      const {
        full_name,
        address,
        date_of_birth,
        postal_code,
        town_city,
        recommendation,
        type,
        country_iso,
        KycProvider,
        nationality_iso2,
      } = response.kycData;

      const user_info = {
        full_name,
        date_of_birth,
        Nationality: nationality_iso2,
        Postcode: country_iso === account_country_code ? postal_code : "",
        Address: country_iso === account_country_code ? address : "",
        TownCity: country_iso === account_country_code ? town_city : "",
        countryCode: country_code_iso2,
      };

      if (KycProvider === "endeavour") {
        return window.OrendaGetResponse(
          { event_name: "final checks", data: JSON.stringify(user_info) },
          (response) => goToScreen(history, response.current_screen)
        );
      }
      setDetails(user_info);
      setLoading(false);

      // fail liveliness or document authentication
      if (recommendation !== "APPROVE" && type !== "AML")
        return setRepeatYoti(true);

      return;
    }

    if (isSiteBuilder()) {
      setTimeout(() => {
        setDetails({
          full_name: "Jim Jon",
          date_of_birth: "1976-02-01",
          Nationality: null,
          Postcode: "M25 0AH",
          Address: "1 Downing Street",
          TownCity: "London",
          countryCode: "UK",
        });
        setLoading(false);
      }, 2000);
      return;
    }

    window.OrendaGetResponse(
      { event_name: "page load - confirm" },
      handleChange,
      false
    );
    return;
  }, [history]);

  if (loading) return <Loader />;

  if (repeatYoti)
    return (
      <BackgroundPhoto>
        <h5>Unfortunately we need you to re-do the ID verification process.</h5>
        <h5 style={{ marginTop: 5 }}>
          You won't have to re-do our chatbot as we have saved your answers.
        </h5>
        <Button
          style={{ marginTop: 25 }}
          size="lg"
          block
          variant="dark"
          onClick={() => {
            if (isSiteBuilder()) return;
            window.OrendaGetResponse(
              { event_name: "redo Yoti" },
              (response) => goToScreen(history, response.current_screen),
              false
            );
            setLoading(true);
            return;
          }}
        >
          I'm ready
        </Button>
      </BackgroundPhoto>
    );

  return (
    <div className="orenda-frontend">
      <ConfirmDetails
        details={details}
        setDetails={setDetails}
        onConfirm={async () => {
          if (isSiteBuilder()) {
            console.log(details);
            return;
          }

          window.OrendaGetResponse(
            {
              event_name: "final checks",
              data: JSON.stringify(details),
            },
            (response) => goToScreen(history, response.current_screen),
            false
          );
          return;
        }}
        onReDo={async () => {
          if (isSiteBuilder()) return;
          window.OrendaGetResponse(
            { event_name: "redo Yoti" },
            (response) => goToScreen(history, response.current_screen),
            false
          );
          return;
        }}
      />
    </div>
  );
}
